<div class="flex items-center justify-center dialog-header ">
    {{ type }} Role

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>
</div>

<div>
    <form [formGroup]="permissionForm" (ngSubmit)="onSubmit()" class="dialog-content">

        <div class="flex flex-col mb-4">
            <label for="name" class="mb-2 font-semibold">Role Name *</label>
            <input pInputText id="name" formControlName="role_name"
                class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
            <div *ngIf="permissionForm.get('name')?.invalid && (permissionForm.get('name')?.touched || submitted)"
                class="text-red-500 text-xs mt-1">
                Role name is required.
            </div>
        </div>

        <div formArrayName="permissions">
            <div *ngFor="let perm of permissions.controls; let i = index" [formGroupName]="i">
                <div class="my-[25px] mx-[10px]">
                    <p-card class=" shadow-lg rounded-lg ">
                        <!-- Card Header -->
                        <ng-template pTemplate="header">
                            <div class="flex justify-between items-center p-4 pb-0 ">
                                <div>
                                    <h3 class="text-xl font-bold m-0">{{ perm.get('title')?.value }}</h3>
                                    <p class="text-sm text-gray-500">Module: {{ perm.get('module_name')?.value }}</p>
                                </div>
                                <div class="flex items-center space-x-2">
                                    <label class="font-medium text-sm">Status</label>
                                    <p-toggleButton formControlName="active" onLabel="Active" offLabel="Inactive"
                                        offIcon="pi pi-times"></p-toggleButton>
                                </div>
                            </div>
                        </ng-template>

                        <!-- Features Section -->
                        <div formArrayName="features" class="mt-4">
                            <div *ngFor="let feature of getFeatures(i).controls; let j = index" [formGroupName]="j"
                                class="my-4 border border-gray-300 rounded-lg overflow-hidden bg-white">
                                <!-- Feature Title -->
                                <div class="bg-gray-100 px-4 py-2">
                                    <h4 class="font-semibold text-base">{{ feature.get('title')?.value }}</h4>
                                    <p class="text-xs text-gray-500">Feature: {{ feature.get('name')?.value }}</p>
                                </div>

                                <!-- Table Format -->
                                <div class="overflow-auto">
                                    <table class="min-w-full table-auto text-sm">
                                        <thead class="bg-gray-200 text-gray-700">
                                            <tr>
                                                <th class="text-left px-4 py-2">Permission</th>
                                                <th class="text-center px-4 py-2">Allowed</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container *ngFor="let key of feature?.value | keyvalue">
                                                <tr *ngIf="key.key !== 'title' && key.key !== 'name'" class="border-t">
                                                    <td class="px-4 py-2 capitalize">{{ key.key }}</td>
                                                    <td class="px-4 py-2 text-center">
                                                        <p-checkbox [formControlName]="key.key" binary="true"
                                                            inputId="{{'chk_' + i + '_' + j + '_' + key.key}}"></p-checkbox>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </p-card>
                </div>
            </div>
        </div>

        <!-- Sticky Submit Button -->
        <div class="w-full absolute bottom-0 left-0 bg-white p-4 shadow-lg mt-6 z-10 border-t border-gray-200">
            <button pButton 
            [loading]="loading" 
            label="Submit" type="submit" [disabled]="!permissionForm.valid" icon="pi pi-check"
                class="w-full md:w-auto"></button>
        </div>
    </form>

</div>